// extracted by mini-css-extract-plugin
export var Img = "SectionImageText-module--Img--a2140";
export var ImgContainer = "SectionImageText-module--ImgContainer--5d67b";
export var imageText = "SectionImageText-module--imageText--c4562";
export var lnk = "SectionImageText-module--lnk--9c175";